import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './locales/en.js';
import { es } from './locales/es.js';
import { pt } from './locales/pt.js';

/**
 * Admin UI internationalization. Spanish is the default and fallback language. This is
 * a merchant PREFERENCE, kept entirely separate from the storefront form's own
 * config-driven language.
 */
void i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    pt: { translation: pt },
    en: { translation: en },
  },
  lng: 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export const SUPPORTED_LANGUAGES = ['es', 'pt', 'en'] as const;
export default i18n;
